<template>
  <Card>
    <template #header>
      <div class="card-header-custom">
        <h6 class="mb-0 text-primary font-semibold">
          <i class="pi pi-list me-2"></i>
          Queue Status
        </h6>
      </div>
    </template>
    
    <template #content>
      <div v-if="queueStatus">
        <div class="flex justify-content-between align-items-center mb-3">
          <span class="font-medium">Queue Length:</span>
          <Badge class="ms-2" :value="queueStatus.queueLength" severity="info" />
        </div>
        
        <div class="flex justify-content-between align-items-center mb-4">
          <span class="font-medium">Processing:</span>
          <Tag class="ms-2" :value="queueStatus.processing ? 'Yes' : 'No'" 
               :severity="queueStatus.processing ? 'warning' : 'success'" />
        </div>
        
        <div v-if="queueStatus.jobs && queueStatus.jobs.length > 0">
          <h6 class="mb-3 font-semibold">Latest Job:</h6>
          <div class="job-item p-3 border-round surface-border border-1">
            <div class="flex justify-content-between align-items-start mb-2">
              <div>
                <div class="font-semibold text-primary">{{ latestJob.id.substring(0, 8) }}...</div>
                <div class="text-sm text-gray-500 mt-1">
                  {{ latestJob.imageCount }} RAW files
                </div>
              </div>
              <Tag :value="latestJob.status" 
                   :severity="getJobStatusSeverity(latestJob.status)" />
            </div>
            <div class="text-xs text-gray-500 mt-2">
              Created: {{ formatDate(latestJob.createdAt) }}
            </div>
            <div v-if="latestJob.completedAt" class="text-xs text-gray-500">
              Completed: {{ formatDate(latestJob.completedAt) }}
            </div>
            <div v-if="latestJob.error" class="text-xs text-red-500 mt-1">
              Error: {{ latestJob.error }}
            </div>
          </div>
        </div>
      </div>
      
      <div v-else class="text-center py-4">
        <ProgressSpinner style="width: 50px; height: 50px" strokeWidth="4" />
        <p class="text-gray-500 mt-3 mb-0">Loading queue status...</p>
      </div>
    </template>
  </Card>
</template>

<script>
export default {
  name: 'QueueStatus',
  props: {
    queueStatus: Object
  },
  
  computed: {
    latestJob() {
      if (!this.queueStatus?.jobs || this.queueStatus.jobs.length === 0) {
        return null
      }
      // Return the most recent job (first item, as jobs are typically sorted by creation date desc)
      return this.queueStatus.jobs[0]
    }
  },
  
  methods: {
    getJobStatusClass(job) {
      return `job-status-${job.status}`
    },
    
    getJobStatusSeverity(status) {
      switch (status) {
        case 'pending': return 'warning'
        case 'processing': return 'info'
        case 'completed': return 'success'
        case 'failed': return 'danger'
        default: return 'secondary'
      }
    },
    
    formatDate(dateString) {
      return new Date(dateString).toLocaleString()
    }
  }
}
</script>

<style scoped>
.card-header-custom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.25rem 1.5rem;
  border-bottom: 1px solid var(--surface-border);
  background: var(--surface-50);
}

.job-item {
  background: var(--surface-0);
  transition: all 0.2s ease;
}

.job-item:hover {
  background: var(--surface-50);
}
</style>